import styled from 'styled-components';

import List from 'components/list';
import { Col, Row } from 'components/grid';
import DraggableList from 'components/draggableList';

const StyledCol = styled(Col)`
  display: flex;
  justify-content: center;
  text-align: center;
`;

const StyledHeader = styled(Row)`
  margin-bottom: 8px;
  margin-left: 32px;
  ${({ theme }) => theme.typograph.subTitleMedium}
`;

const StyledColField = styled(Col)`
  padding-left: 16px;
`;

const Wrapper = styled.div`
  margin-bottom: 32px;
`;

const FilterTypeText = styled.p`
  ${({ theme }) => theme.typograph.subTitleMedium}
  color: ${({ theme }) => theme.colors.mainColorContrast};
  margin-bottom: 8px;
`;

const ListStyled = styled(List)`
  margin-bottom: 32px;
`;

const DraggableListStyled = styled(DraggableList)`
  margin-bottom: 32px;
`;

const SaveButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 48px;
`;

const DividerLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.gray300};
  margin-bottom: 32px;
`;

const StyledColForList = styled(Col)`
  display: flex;
  align-items: center;
`;

const ModificationsText = styled.p`
  ${({ theme, hasModification }) => (hasModification ? theme.typograph.paragraphMedium : theme.typograph.paragraphRegular)};
  color: $${({ theme, hasModification }) => (hasModification ? theme.colors.mainColor : theme.colors.textColorSecondary)};
  margin-right: 24px;
`;

export {
  FilterTypeText,
  SaveButtonWrapper,
  DividerLine,
  ListStyled,
  Wrapper,
  StyledColField,
  StyledCol,
  StyledHeader,
  DraggableListStyled,
  StyledColForList,
  ModificationsText,
};
